import React, { useEffect, useCallback, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import {
    action_fetch_unpaid_checkout,
    action_refresh_unpaid_checkout,
    action_set_unpaid_method,
    setUnpaidRefreshing,
    action_fetch_card_list,
} from '../../../../../store/actions/pages/cart'

import { update_order_address, klarna_order_create_session, klarna_order_get_params, getCountryAppMessage } from '../../../../../api'

import Page from '../../layout/normal-page'
import { NBoxes, Box } from '../../layout/box'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector, useDispatch, useStore } from 'react-redux'
import LoadingPage from './fragments/loading-page'
import Loading from '../../../../components/loading/op-loading'
import EmptyPage from './fragments/empty-page'
import OrderSummary from '../checkout/fragments/order-summary'
import Address from './fragments/address'
import AddressEditor from '../../fragments/address/address-editor'
import Cache from '../../../../../utils/cache'
import Line, { Lines } from './components/line'
import PayMethod from './fragments/pay-method'
import ShippingMethod from './fragments/shipping-method'
import OrderItems from './fragments/order-items'
import moment from 'moment/moment'
import { Iconfont } from '../../../../components/icon/iconfont'
import { TOOGLE_UI_CONFIRM, TOOGLE_UI_ALERT } from '../../../../../store/actions/ui'
import PayNowFooter from './fragments/paynow-footer'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import copy from 'copy-to-clipboard'
import OrderCancelButton from './fragments/order-cancel-button'
import toast from '../../../../components/toast'
import * as Paymethods from '../../../../../utils/paymethods'

const UnpaidOrder = props => {
    useStyles(classes)

    const {
        unpaid,
        unpaidIniting,
        unpaidRefreshing,
        unpaidEmpty,
    } = useSelector(state => state.pageCart)

    const dispatch = useDispatch()
    const store = useStore()
    const history = useHistory()
    const params = useParams()
    const query = useQuery()
    const Intl = useIntl()
    const global = useSelector(state => state.global)
    const [privacyMsg, setPrivacyMsg] = useState(null)

    const [addressEditor, setAddressEditor] = useState({})
    const [klarnas, setKlarnas] = useState(null)
    const [showMethodList, setShowMethodList] = useState(!!query?.selectPayment)
    const [selectedCard, setSelectedCard] = useState(null)

    useEffect(async () => {
        if(!privacyMsg){
            const res = await getCountryAppMessage("M1840")
            if(res?.code == 200){
                // privacyMsg.current = res?.result || {}
                setPrivacyMsg(res?.result || {})
            }
        }
    }, [])

    useEffect(() => {

        // Cache.remove('temp-order')

        if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if (!unpaid) {
                UnpaidOrder.fetchData(store, params, query, null)
            }
        }

        window.scrollTo({
            top: 0,
        })

        if(query.errMsg && query.errMsg !== 'undefined' && query.errMsg !== 'null'){
            handleError({message: query.errMsg})
        }

    }, [])

    useEffect(async () => {
        const selectedPayMethod = unpaid?.payMethods?.find(p => p.id === unpaid.payMethod)
        if (unpaid) {
            if(window.Klarna && selectedPayMethod?.type === '27'){
                const response = await klarna_order_create_session({ payMethod: unpaid.payMethod, orderId: unpaid.orderId })
                if (response?.code === 200 && response?.result) {
                    const { client_token } = response.result
                    window.Klarna.Payments.init({
                        client_token
                    })
                    const paramsResponse = await klarna_order_get_params({ payMethod: unpaid.payMethod, orderId: unpaid.orderId })
                    if (paramsResponse?.code === 200 && paramsResponse?.result) {
                        const params = paramsResponse?.result
                        setKlarnas(params)
                    }
                }
            }


            try {
                const creditMethod = unpaid.payMethods?.find(p => p.id === '88' || p.id === '91' || p.id === '101' || p.id === '109')
                if (creditMethod) {
                    const cardList = await dispatch(action_fetch_card_list(Paymethods.getRelatedPayMethods(creditMethod.id)))
                    if (cardList?.length > 0) {
                        setSelectedCard(cardList.find(c => c.isSelected))
                    }else{
                        setSelectedCard(null)
                    }
                }else{
                    setSelectedCard(null)
                }
            } catch (error) {

            }
        }
    }, [unpaid])

    useEffect(() => {
        if(unpaidEmpty){
            window.location.replace(`/user/order/detail/${params.orderId}`)
        }
    }, [unpaidEmpty])

    const backHandle = () => {
        // if (document.referrer?.indexOf('/order') > 0) {
        //     window.history.back()
        // } else {
            // window.location.href = '/'
        // }
        history.goBack()
    }

    const editAddressHandle = e => {
        setAddressEditor({
            show: true,
            address: unpaid.shippingDetail
        })
    }

    const onSubmitAddress = async values => {
        const response = await update_order_address({
            ...values,
            transactionId: unpaid?.transactionId
        })
        if (response?.code === 200) {
            dispatch(action_refresh_unpaid_checkout(unpaid.orderId))
            setAddressEditor({
                address: null,
                show: false
            })
            if (values?.email) {
                Cache.set('customerEmail', values?.email, 365 * 24 * 60 * 60)
            }
        }
        return response
    }

    const selectPayMethodHandle = async payMethod => {
        await dispatch(action_set_unpaid_method({ payMethod, orderId: unpaid.orderId }))
    }

    const handleError = state => {
        if (state.type === 'no_paymethod') {
            //no paymethod
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: <FormattedMessage id="select_pay_method" defaultMessage="Please select a pay method!" />,
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                        }
                    }
                }
            })
        } else if (state.message) {
            dispatch({
                type: TOOGLE_UI_ALERT,
                payload: {
                    show: true,
                    options: {
                        content: state.message,
                        onConfirm: () => {
                            dispatch({ type: TOOGLE_UI_ALERT, options: null })
                        }
                    }
                }
            })
        }
    }

    const copyOrderId = (orderNumber) => {
        if (copy(orderNumber)) {
            toast(Intl.formatMessage({ id: "copy_success", defaultMessage: "Copy Success" }))
        } else {
            toast(Intl.formatMessage({ id: "copy_fail" }))
        }
    }

    return <Page  privacyMsg={privacyMsg} title={<FormattedMessage id="order_details" defaultMessage="Order Details" />} onBack={backHandle}>
        {
            unpaidIniting && <LoadingPage />
        }
        {
            unpaidRefreshing && <Loading />
        }

        {
            unpaidEmpty && <LoadingPage />
        }

        {
            unpaid && !unpaidEmpty && !unpaidIniting && <>
                <NBoxes>
                    <Box>
                        <Lines>
                            <Line title={<FormattedMessage id="order_no" defaultMessage="Order No." />}>
                                <span className={classes.OrderCopy} onClick={() => copyOrderId(unpaid.orderId)}>
                                    <span className={classes.Label}>{unpaid.orderId}</span>
                                    <Iconfont className={classes.Icon}>&#xe776;</Iconfont>
                                </span>
                            </Line>
                            <Line title={<FormattedMessage id="payment_date" defaultMessage="Payment Date" />}>
                                <span className={classes.SmallText}>{moment(unpaid.orderTime).format('YYYY/MM/DD HH:mm:ss')}</span>
                            </Line>
                        </Lines>

                    </Box>
                    <Box>
                        <Lines>
                            <Address address={unpaid.shippingDetail} onEdit={editAddressHandle} />
                            <PayMethod
                                payMethod={unpaid.payMethod}
                                payMethods={unpaid.payMethods}
                                klarnas={klarnas}
                                orderTotal={unpaid.orderTotal}
                                onEdit={() => setShowMethodList(true)}
                                selectedCard={selectedCard}
                            />
                        </Lines>
                    </Box>
                    <Box>
                        <ShippingMethod shippingMethod={unpaid.shippingMethod} />
                    </Box>
                    <Box>
                        <Lines>
                            <OrderItems checkoutItems={unpaid.checkoutItems} />
                            <OrderSummary orderSummary={{
                                display: unpaid.display,
                                doublePointsMultiple: unpaid.doublePointsMultiple
                            }} />
                            <OrderCancelButton order={unpaid}/>
                        </Lines>
                    </Box>
                </NBoxes>
                
                <PayNowFooter
                    showMethodList={showMethodList}
                    setShowMethodList={setShowMethodList}
                    onError={handleError}
                    country={unpaid.shippingDetail?.country?.value}
                    klarnas={klarnas}
                    orderTotal={unpaid.orderTotal}
                    payMethod={unpaid.payMethods?.find(p => p.id === unpaid.payMethod)}
                    payMethods={unpaid.payMethods}
                    selectPayMethodHandle={selectPayMethodHandle}
                    selectedCard={selectedCard}
                    inputOrder={{
                        id: unpaid.orderId,
                        transactionId: unpaid?.transactionId,
                        serverTime: unpaid.serverTime,
                        orderTime: unpaid.expiredPaymentTime
                    }}
                />
            </>
        }

        <AddressEditor disableCountry address={addressEditor?.address} onSubmit={onSubmitAddress} onClose={e => setAddressEditor({ ...addressEditor, show: false })} show={addressEditor?.show} />

    </Page>
}

UnpaidOrder.fetchData = async (store, params, search, headers) => {
    const { orderId } = params
    await store.dispatch(action_fetch_unpaid_checkout(orderId, headers))
}

export default UnpaidOrder